/** テンプレートプレビュー閲覧可否ステータス */
class TemplatePreview {
    /** テンプレートプレビュー閲覧許可 */
    static ALLOW = { code: "1", icon: "allow" };
    /** テンプレートプレビュー閲覧不可 */
    static NOTALLOW = { code: "0", icon: "notAllow" };
}
export { TemplatePreview };
